module.exports = __webpack_public_path__ + "assets/img/sabc_main_logo.gif?efab47ea8ae9753a493013a965211ca6";